import type { Elevation } from "./types";

const PAD_X = 34;
const PAD_Y = 10;

// Square-root widths: a 40 m tray run must not squeeze a 2 m spur to nothing.
export const elevation: Elevation = ({ profile, width, height }) => {
  const heights = [
    0,
    profile.boardM,
    profile.deviceM,
    ...profile.legs.flatMap((leg) => [leg.fromM, leg.toM]),
  ];
  const top = Math.max(...heights, 1);
  const bottom = Math.min(...heights);
  const yOf = (metres: number) =>
    PAD_Y + ((top - metres) / (top - bottom || 1)) * (height - 2 * PAD_Y);
  const runs = profile.legs.filter((leg) => leg.kind === "run");
  const weights = runs.map((leg) => Math.sqrt(Math.max(leg.lengthM, 0.1)));
  const totalWeight = weights.reduce((sum, weight) => sum + weight, 0) || 1;
  const span = width - PAD_X - 8;

  let x = PAD_X;
  let runIndex = 0;
  const points = [{ x, y: yOf(profile.boardM), isVertical: false }];
  profile.legs.forEach((leg) => {
    if (leg.kind === "run") {
      x += (weights[runIndex] / totalWeight) * span;
      runIndex += 1;
      points.push({ x, y: yOf(leg.toM), isVertical: false });
      return;
    }
    points.push({ x, y: yOf(leg.toM), isVertical: true });
  });

  const distinct = [...new Set(heights.slice(1).map((metres) => Math.round(metres * 100) / 100))];
  return {
    points,
    levels: distinct.map((heightM) => ({ heightM, y: yOf(heightM) })),
    floorY: yOf(0),
  };
};
